export const LINK_CHAR = "\u21A0"; // no itx

export const TAG_ENVIRONMENT = "TX_E"; // no itx
export const TAG_TEMPERATUR = "TX_T"; // no itx
export const TAG_SPECIAL = "TX_S";  // no itx
export const TAG_IGNORE = "TX_I";  // no itx
export const TAG_MANUAL_SIGNALS = "TX_MS";  // no itx
export const TAG_TX = "TX"; // no itx


export const EtsImportProductIdPrefix = "ETSI-"; // no itx 

